import React from 'react'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/header.css')
require('../style/css/custom/components/footer.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')
require('../js_animations/navResets.js')


const Footer = ({
  myEmail,
  myPhone,
  logo_white_PNG,
  logo_blue_PNG_960,
  logo_blue_PNG_100,
  logo_blue_PNG_70,
  logo_blue_PNG_16,
  backToTop_icon

}) => (

<div className="footer" id="footer">


  <a href="#_top" className="_topClicked">
    <div className="backToTop wow animated fadeIn" id="backToTop_hover">
      <img className="backToTop_icon" src={backToTop_icon} alt="backToTop_icon" />
    </div>
    <div className="backToTop wow animated fadeIn" id="backToTop">
      <img className="backToTop_icon" src={backToTop_icon} alt="backToTop_icon" />
    </div>
  </a>

  <img src={logo_blue_PNG_960} alt="logo_big" className="footer__logo wow fadeIn" id="footer_logo" data-wow-offset="100" />

  <p className="footer_quote wow fadeIn" data-wow-offset="50">
    "Nothing worthwhile is easy"
  </p>

  <p className="copyright wow fadeIn" data-wow-offset="20">
    David Chamberlin - Web Developer + UX Designer + Artist + Musician<br />
    © 2017
  </p>

</div>

)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js